<template>
    <div class="py-8 md:py-10">
        <HelpCenterSearchForm />
    </div>
</template>

<script setup lang="ts">
    import HelpCenterSearchForm from '@/HelpCenter/Component/HelpCenterSearchForm.vue'
</script>
